/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Model_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search models..." |
*
* @param {Preferences_Model_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_model_search_placeholder = /** @type {((inputs?: Preferences_Model_Search_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Model_Search_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modelle suchen...")
	return /** @type {LocalizedString} */ ("Search models...")
});